import script from "./FiltroComponentSimplificado.vue?vue&type=script&setup=true&lang=js"
export * from "./FiltroComponentSimplificado.vue?vue&type=script&setup=true&lang=js"

import "./FiltroComponentSimplificado.vue?vue&type=style&index=0&id=a8c0e36a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a8c0e36a"]])

export default __exports__